import React, { useState } from "react";
import Australiainvestorvisaimport from "@/pages/australiainvestorvisaimport"
import Contacts from "@/pages/contacts";
const Australiainvestorvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/australiya.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
          {/* <div className="absolute bottom-5 left-5 text-3xl font-bold text-[#011473] rop-shadow-md">
          Welcome to Visa World Immigration – Your Gateway to Investing in Australia
          </div> */}
        </div>
      </div>
      
      <div className="text-center text-3xl font-bold text-[#011473]  drop-shadow-md mt-10 mx-auto md:ml-32 w-full md:w-3/4">
  Visa World – Your Pathway to Australia
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-4">
        {/* Left Section: Image */} 

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/fees.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-4 lg:w-1/2">
  

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Age: </a>Applicants must meet the age requirements.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">  Points:</a> Must achieve the required points score.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">  English:</a> Proof of English proficiency is necessary.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Permanent Residency:</a> Provides permanent residence for the applicant and their family.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Stay:</a> Allows indefinite stay in Australia.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Work & Study:</a> Full rights to work and study in Australia.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Medicare:</a> Access to Australia’s healthcare system.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Citizenship:</a> Eligibility for Australian citizenship.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="http://www.w3.org/2000/svg" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Sponsorship:</a> Can sponsor eligible relatives for permanent residency.
    </span>
  </div>
</div>


      </div>
      <Australiainvestorvisaimport />
      
      <div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center text-black rounded-md bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        <strong>Planning to Invest in Australia and Need an Investor Visa?: </strong>  
        Visa World Immigration is here to assist you in navigating the Investor Visa process.
        <br />
        <strong>Expert Guidance: </strong>  
        Our team of seasoned consultants offers thorough assistance, including detailed insights into the Australia Investor Visa.
        <br />
        <strong>Key Information Provided: </strong>  
        We cover the eligibility criteria, required documents and step-by-step application instructions.
        <br />
        <strong>SEO-Optimized Page: </strong>  
        This page is designed to be SEO-friendly, filled with high-ranking keywords to help you easily access the information you need.
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Australia Investor Visa Information
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>


      
      <Contacts />
    </>
  );
};

export default Australiainvestorvisa;
